module.exports = __webpack_public_path__ + "static/musee_olympique_stades6-9ca5d10e4934bf428bf1e9d8bbab164d.png";